// Components — the primary surface most callers use.
export * from "./components/index.js";

// Spec builders — pure functions for composing or server-rendering specs.
export * from "./specs/index.js";

// Theme — palette resolution and Vega-Lite config generation.
export * from "./theme/index.js";

// Shared data/encoding types.
export type {
  ChartData,
  ChartDatum,
  FieldType,
  StackMode,
  BaseChartSpecOptions,
} from "./types.js";

// Re-export the core Vega-Lite spec type so consumers can type hand-written specs.
export type { TopLevelSpec } from "vega-lite";

// Re-export the compiler so consumers can validate untrusted/generated specs
// without depending on vega-lite directly (compiling is Vega-Lite's only
// runtime validation — a spec that compiles is renderable).
export { compile } from "vega-lite";
